import React from 'react'

import MetabaseEmbed from '@aletheia/common/components/MetabaseEmbed'

import { GrantCount } from './GrantCount'
import { PayoutChartDataPoint, PayoutsByFund } from './PayoutsByFund'

export const StatisticsPayouts = ({
  data,
}: {
  data?: PayoutChartDataPoint[]
}) => {
  return (
    <>
      {data && <GrantCount data={data} />}

      {data && <PayoutsByFund data={data} />}

      <MetabaseEmbed
        embedType="chart"
        title="Fund Balance, last three years"
        src="https://dashboard.effectivealtruism.org/public/question/c2d496ec-f6bc-472d-a0c4-af6e2cfef505"
      />
    </>
  )
}

export default StatisticsPayouts
